import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

type RadioProps = {
  value: any;
  onChange: (value: any) => void;
  menulist: any;
  labelPlacement: "end" | "start" | "top" | "bottom" | undefined;
  label: string;
  className?: string;
  id?: string;
  name?: string;
  disabled?: true | false;
};

export default function RadioComponent(props: RadioProps) {
  return (
    <FormControl>
      <RadioGroup
        name={props.name}
        id={props.id}
        value={props.value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          props.onChange(event.target as HTMLInputElement);
        }}
      >
        {props.menulist.map((item: any, index: any) => {
          return (
            <FormControlLabel
              key={index}
              value={index + 1}
              control={<Radio />}
              label={item[props.label]}
              labelPlacement={props.labelPlacement}
              className={props.className}
              disabled={props.disabled}
            ></FormControlLabel>
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
